import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { StyledCardsWrapperContent } from "./styles";

interface IProps {
    title?: string;
}

const CardsWrapper = ({ title, children }: React.PropsWithChildren<IProps>): React.ReactElement => {
    return (
        <Flex
            flexDirection="column"
            gap="8px"
        >
            {title ? (
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon["300"]}
                >
                    {title}
                </Text>
            ) : null}

            <StyledCardsWrapperContent>{children}</StyledCardsWrapperContent>
        </Flex>
    );
};

export default CardsWrapper;
